module.exports = __webpack_public_path__ + "static/media/yellowCurve.6c80c63e.svg";